
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const useDeleteClientPayment = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (paymentId: string) => {
      console.log('Deleting payment:', paymentId);

      // Use RPC function - TypeScript doesn't know about it yet but it exists
      const { error: deleteError } = await supabase
        .rpc('delete_client_payment' as any, { p_payment_id: paymentId });

      if (deleteError) {
        console.error('Error deleting payment:', deleteError);
        throw deleteError;
      }

      return paymentId;
    },
    onSuccess: (paymentId, variables, context) => {
      console.log('Payment deleted successfully, invalidating all related queries...');
      // Invalidate all payment-related queries
      queryClient.invalidateQueries({ queryKey: ['clientPayments'] });
      queryClient.invalidateQueries({ queryKey: ['subscriptionPayments'] });
      // Invalidate client queries to refresh payment status
      queryClient.invalidateQueries({ queryKey: ['clients'] });
      queryClient.invalidateQueries({ queryKey: ['client'] });
      toast.success('Payment deleted successfully');
    },
    onError: (error) => {
      console.error('Error in delete payment mutation:', error);
      toast.error('Failed to delete payment');
    }
  });
};
